<template>
  <div class="poi-mini-cta" ref="content">
    <vs-button class="glass-cta" @click="openPoi" :disabled="!poiDetails" :upload="isLoading">
      <img v-if="poiDetails" class="icon" :src="targets[poiDetails.target_id]" alt="" />
      <span class="name">{{ poiDetails ? poiDetails.name : '...' }}</span>
    </vs-button>
  </div>
</template>

<script>
import { apiCall } from '../utils/ApiMiddleware';
import POI from './elements/POI.vue';
import { GlobalEventEmitter } from '@/utils/GlobalEventEmitter';

export default {
  name: 'PoiMiniCTA',
  props: {
    poiId: {
      type: [String, Number],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: null
    },
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      poiDetails: null,
      poiPanel: null,
      isLoading: false
    };
  },
  computed: {
    targets() {
      return this.$TARGETS.icons || [];
    }
  },
  methods: {
    async getPoi(id) {
      this.isLoading = true;
      const response = await apiCall('GET', '/pois/' + id);
      if (response.status == 200) {
        this.poiDetails = response.data;
      } else if (response.status != 0) {
        this.$vs.notification({
          title: 'Qualcosa è andato storto!',
          text: 'Impossibile caricare il punto di interesse, riprova più tardi.',
          color: 'danger',
          position: 'top-right'
        })
      }
      this.isLoading = false;
    },
    openPoi() {
      if (!this.poiDetails) return;
      const mobile = this.isMobile !== null ? this.isMobile : (typeof window !== 'undefined' ? window.innerWidth < 600 : false);

      if (mobile) {
        try {
          // mimic PoiSearch mobile behavior
          GlobalEventEmitter.$emit('setMobileNavbarVisible', false);
          GlobalEventEmitter.$emit('poiPanelOpen');
          GlobalEventEmitter.$emit('invalidateMap');
          // visually minimize AI panel behind POI
          GlobalEventEmitter.$emit('aiPanelPeek');

          const lat = this.poiDetails.latitude;
          const lng = this.poiDetails.longitude;
          if (lat != null && lng != null) {
            // immediately center the map (no offset) so the position is correct under the sheet
            GlobalEventEmitter.$emit('goToCoords', [lat, lng]);
            // then reinforce with an offset-based recenter using 0px offset to keep true center
            setTimeout(() => {
              GlobalEventEmitter.$emit('centerWithOffset', { lat, lng, offsetYpx: 0 });
            }, 80);
            setTimeout(() => {
              GlobalEventEmitter.$emit('centerWithOffset', { lat, lng, offsetYpx: 0 });
            }, 350);
          }

            this.poiPanel = this.$showPanel({
                component: POI,
                openOn: 'bottom',
                cssClass: 'poi-mobile-panel',
                props: {
                    poiId: this.poiId,
                    user: this.user,
                    isMobile: true,
                    // open taller when coming from AI so the header isn't cramped
                    initialSheetRatio: 0.86,
                    fromAssistant: true,
                    close: () => {
                        if (this.poiPanel) {
                            this.poiPanel.hide();
                        }
                        // restore AI panel visual state
                        GlobalEventEmitter.$emit('aiPanelRestore');
                    }
                }
            });

          if (this.poiPanel && this.poiPanel.promise) {
            this.poiPanel.promise.then(() => {
              GlobalEventEmitter.$emit('setMobileNavbarVisible', true);
              GlobalEventEmitter.$emit('poiPanelClose');
              GlobalEventEmitter.$emit('aiPanelRestore');
              this.poiPanel = null;
            });
          }
        } catch (e) {
          // fallback to route
          this.$router.push({
            name: 'Scheda del luogo',
            params: { id: this.poiDetails.id || this.poiId }
          });
        }
      } else {
        // desktop route navigation
        this.$router.push({
          name: 'Scheda del luogo',
          params: { id: this.poiDetails.id || this.poiId }
        });
      }
    }
  },
  watch: {
    poiId: {
      immediate: true,
      handler(n) {
        if (n != null && n !== '') {
          this.getPoi(n);
        }
      }
    }
  }
};
</script>

<style scoped>
.poi-mini-cta {
  display: inline-flex;
  align-items: center;
}

/* Glass rounded CTA */
.glass-cta {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  margin: 0!important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.55) !important;
  -webkit-backdrop-filter: saturate(150%) blur(10px);
  backdrop-filter: saturate(150%) blur(10px);
  border: 1px solid rgba(39, 48, 63, 0.12) !important;
  color: #27303f !important;
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.12);
  padding: 8px 12px !important;
  height: 36px !important;
}

.icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.name {
  font-size: 13px;
  white-space: nowrap;
}
</style>
